// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_ConnectInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /instagram/accounts/connect
 *
 * Registers an Instagram account with franchise associations.
 */
import { registerContract } from './validate'

export interface InstagramAccounts_ConnectInput {
ig_user_id: string
ig_username: string
access_token: string
franquia_ids: number[]
}

registerContract('InstagramAccounts_ConnectInput', {
  ig_user_id:   { type: 'string',  required: true },
  ig_username:  { type: 'string',  required: true },
  access_token: { type: 'string',  required: true },
  franquia_ids: { type: 'array',   required: true },
})
